import React, {
    useMemo,
    useState,
    useEffect,
} from 'react';
import dayjs from 'dayjs';
// import { FormattedMessage } from 'react-intl';
import { MantineReactTable } from 'mantine-react-table';
// import { useParams } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
import PageTitle from '../../shared/PageTitle';
import { getData } from '../../../services/fetch-service';
// import { Box } from '@mantine/core';

const TableDetails = (props) => {
    // const params = useParams();
    const { locale } = props;
    // const history = useHistory();
    const [TableDetails, setTableDetails] = useState([]);
    const [pronaret, setPronaret] = useState([]);
    const [perfaqesuesit, setPerfaqesuesit] = useState([]);
    const [aktivitetet, setAktivitetet] = useState([]);
    const [njesite, setNjesite] = useState([]);
    const paramsId = useSelector((state) => state.tableSearch.tableDetailsID);
    // const token = useSelector((state) => state.tableSearch.token);

    useEffect(() => {
        getData(`Services/TeDhenatBiznesit?nRegjistriId=${paramsId}&Gjuha=${locale}`).then((response) => {
            setTableDetails(response.data[0].teDhenatBiznesit);
            setPronaret(response.data[0].pronaret);
            setPerfaqesuesit(response.data[0].perfaqesuesit);
            setAktivitetet(response.data[0].aktivitetet);
            setNjesite(response.data[0].njesite);
        })
    }, [paramsId, locale]);

    let headerName;
    let headerSurname;
    let headerPosition;
    let headerAuthorization;
    let headerNameSurname;
    let headerCapitalEuro;
    let headerCapitalPercentage;
    let headerUnitNr;
    let headerUnitName;
    let headerCode;
    let headerPlace;
    let headerDescription;
    let headerType;
    let headerNameBusiness;
    let headerNameTrade;
    let headerTypeBusiness;
    let headerNrUnique;
    let headerNrBusiness;
    let headerNrEmployees;
    let headerDataRegistration;
    let headerMuniciplaity;
    let headerAdress;
    let headerPhone;
    let headerMail;
    let headerCapital;
    let headerStatusARBK;
    let headerAuthRepresentative;
    let headerOwnerShareholders;
    let headerUnits;
    let headerActivity;
    let headerNrFiscal;

    if (locale === 'sq') {
        headerName = 'Emri';
        headerSurname = 'Mbiemri';
        headerPosition = 'Pozita në biznes'
        headerAuthorization = 'Autorizimet';
        headerNameSurname = 'Emri Mbiemri';
        headerCapitalEuro = 'Kapitali në €';
        headerCapitalPercentage = 'Kapitali në %';
        headerUnitNr = 'Numri i Njësisë';
        headerUnitName = 'Emri i Njësisë';
        headerCode = 'Kodi';
        headerPlace = 'Vendi';
        headerDescription = 'Përshkrimi';
        headerType = 'Tipi';
        headerNameBusiness = 'Emri i biznesit';
        headerNameTrade = 'Emri tregtar';
        headerTypeBusiness = 'Lloji biznesit';
        headerNrUnique = 'Numri unik identifikues';
        headerNrBusiness = 'Numri i biznesit';
        headerNrEmployees = 'Numri punëtorëve';
        headerDataRegistration = 'Data e regjistrimit';
        headerMuniciplaity = 'Komuna';
        headerAdress = 'Adresa';
        headerPhone = 'Telefoni';
        headerMail = 'E-mail';
        headerCapital = 'Kapitali';
        headerStatusARBK = 'Statusi në ARBK';
        headerAuthRepresentative = 'Përfaqësuesi i autorizuar';
        headerOwnerShareholders = 'Pronar/ Aksionarë';
        headerUnits = 'Njësitë';
        headerActivity = 'Aktivitet/et';
        headerNrFiscal = 'Numri Fiskal'
    } else if (locale === 'en') {
        headerName = 'Name'
        headerSurname = 'LastName'
        headerPosition = 'Position in business';
        headerAuthorization = 'Authorization';
        headerNameSurname = 'Name Surname';
        headerCapitalEuro = 'Capital in €';
        headerCapitalPercentage = 'Capital in %';
        headerUnitNr = 'Unit Number';
        headerUnitName = 'Name';
        headerCode = 'Code';
        headerPlace = 'Place';
        headerDescription = 'Description';
        headerType = 'Type';
        headerNameBusiness = 'Business Name';
        headerNameTrade = 'Trade Name';
        headerTypeBusiness = 'Type of business';
        headerNrUnique = 'Unique identification number';
        headerNrBusiness = 'Business number';
        headerNrEmployees = 'Number of employees';
        headerDataRegistration = 'Registration date';
        headerMuniciplaity = 'Municipality';
        headerAdress = 'Address';
        headerPhone = 'Phone number';
        headerMail = 'E-mail';
        headerCapital = 'Capital';
        headerStatusARBK = 'Status in KBRA';
        headerAuthRepresentative = 'Authorised persons';
        headerOwnerShareholders = 'Owner/ Shareholders';
        headerUnits = 'Units';
        headerActivity = 'Activity/ies';
        headerNrFiscal = 'Fiscal number'
    } else if (locale === 'sr') {
        headerName = 'Ime'
        headerSurname = 'Prezime';
        headerPosition = 'Položaj u poslu';
        headerAuthorization = 'Ovlašćenje';
        headerNameSurname = 'Ime Prezime';
        headerCapitalEuro = 'Kapital u €';
        headerCapitalPercentage = 'Kapital u %';
        headerUnitNr = 'Br. Broj jedinice';
        headerUnitName = 'Ime';
        headerCode = 'Kod';
        headerPlace = 'Zemlja';
        headerDescription = 'Opis';
        headerType = 'Tip';
        headerNameBusiness = 'Naziv biznisa';
        headerNameTrade = 'Trgovačko ime';
        headerTypeBusiness = 'Vrsta biznisa';
        headerNrUnique = 'Jedinstveni identifikacioni broj';
        headerNrBusiness = 'Broj biznisa';
        headerNrEmployees = 'Broj radnika';
        headerDataRegistration = 'Datum registracije';
        headerMuniciplaity = 'Opština';
        headerAdress = 'Adresa';
        headerPhone = 'Telefon';
        headerMail = 'E-mail';
        headerCapital = 'Kapital';
        headerStatusARBK = 'Status u KARB-u';
        headerAuthRepresentative = 'Ovlašćena Lica';
        headerOwnerShareholders = 'Vlasnik/ Akcionari';
        headerUnits = 'Jedinica';
        headerActivity = 'Aktivnost/i';
        headerNrFiscal = 'Fiskalni broj'
    }

    const perfaqesuesitColumns = useMemo(
        () => [
            {
                accessorKey: 'Emri',
                header: [headerName],
            },
            {
                accessorKey: 'Mbiemri',
                header: [headerSurname],
            },
            {
                accessorKey: 'Pozita',
                header: [headerPosition],
            },
            {
                accessorKey: 'Autorizimet',
                header: [headerAuthorization],
            },
        ],
        [],
    );

    const pronaretColumns = useMemo(
        () => [
            {
                accessorKey: 'Pronari',
                header: [headerNameSurname],
            },
            {
                accessorKey: 'Kapitali',
                header: [headerCapitalEuro],
            },
            {
                accessorKey: 'KapitaliPerqindje',
                header: [headerCapitalPercentage],
            },
        ],
        [],
    );

    const njesiteColumns = useMemo(
        () => [
            {
                accessorKey: 'Numri',
                header: [headerUnitNr],
            },
            {
                accessorKey: 'Emri',
                header: [headerUnitName],
            },
            {
                accessorKey: 'NaceKodi',
                header: [headerCode],
            },
            {
                accessorKey: 'Vendi',
                header: [headerPlace],
            },
            // {
            //     accessorKey: 'LlojiAktivitetit',
            //     header: 'Vendi',
            // },
        ],
        [],
    );

    const aktivitetetColumns = useMemo(
        () => [
            {
                accessorKey: 'KodiNace',
                header: [headerCode],
                size: 50,
            },
            {
                accessorKey: 'Pershkrimi',
                header: [headerDescription],
                size: 500,
            },
            {
                accessorKey: 'LlojiAktivitetit',
                header: [headerType],
            },
        ],
        [],
    );

    return (
        <div className="arbk-details">
            <PageTitle header={TableDetails.EmriBiznesit} />
            <div className="table-details">
                <table>
                    <tr>
                        <th>{headerNameBusiness}</th>
                        <td>{TableDetails.EmriBiznesit}</td>
                    </tr>
                    <tr>
                        <th>{headerNameTrade}</th>
                        <td>{TableDetails.EmriTregtar}</td>
                    </tr>
                    <tr>
                        <th>{headerTypeBusiness}</th>
                        <td>{TableDetails.LlojiBiznesit}</td>
                    </tr>
                    <tr>
                        <th>{headerNrUnique}</th>
                        <td>{TableDetails.NUI}</td>
                    </tr>
                    <tr>
                        <th>{headerNrBusiness}</th>
                        <td>{TableDetails.NumriBiznesit}</td>
                    </tr>
                    <tr>
                        <th>{headerNrFiscal}</th>
                        <td>{TableDetails.NumriFiskal}</td>
                    </tr>
                    {/* <tr>
                        <th>Numri certifikues KTA</th>
                        <td>{TableDetails.NumriBiznesit}</td>
                    </tr> */}
                    <tr>
                        <th>{headerNrEmployees}</th>
                        <td>{TableDetails.NumriPunetoreve}</td>
                    </tr>
                    <tr>
                        <th>{headerDataRegistration}</th>
                        <td>
                            {dayjs(TableDetails.DataRegjistrimit).format('DD/MM/YYYY')}
                        </td>
                    </tr>
                    <tr>
                        <th>{headerMuniciplaity}</th>
                        <td>{TableDetails.Komuna}</td>
                    </tr>
                    <tr>
                        <th>{headerAdress}</th>
                        <td>{TableDetails.Adresa}</td>
                    </tr>
                    <tr>
                        <th>{headerPhone}</th>
                        <td>{TableDetails.Telefoni}</td>
                    </tr>
                    <tr>
                        <th>{headerMail}</th>
                        <td>{TableDetails.Email}</td>
                    </tr>
                    <tr>
                        <th>{headerCapital}</th>
                        <td>{TableDetails.Kapitali}</td>
                    </tr>
                    <tr>
                        <th>{headerStatusARBK}</th>
                        <td>{TableDetails.StatusiARBK}</td>
                    </tr>
                    {/* <tr>
                        <th>Statusi në ATK</th>
                        <td>Cell 3</td>
                    </tr> */}
                </table>
            </div>
            <div className="TableSearch-section">
                <div className="content-details">
                    <h4>{headerAuthRepresentative}</h4>
                    <div className="table-search" style={{ overflow: 'hidden' }}>
                        <MantineReactTable
                            className="mantine-table"
                            columns={perfaqesuesitColumns}
                            data={perfaqesuesit ?? []}
                            enableGlobalFilter={false}
                            enableGlobalFilterModes={false}
                            enableFilterMatchHighlighting={false}
                            enableGlobalFilterRankedResults={false}
                            enableBottomToolbar={false}
                            search={false}
                            enableTopToolbar={false}
                            enableColumnFilters={false}
                            enablePagination={false}
                            state={{ isLoading: false }}
                        />
                    </div>
                </div>

                <div className="content-details">
                    <h4>{headerOwnerShareholders}</h4>
                    <div className="table-search" style={{ overflow: 'hidden' }}>
                        <MantineReactTable
                            className="mantine-table"
                            columns={pronaretColumns}
                            data={pronaret ?? []}
                            enableGlobalFilter={false}
                            enableGlobalFilterModes={false}
                            enableFilterMatchHighlighting={false}
                            enableGlobalFilterRankedResults={false}
                            enableBottomToolbar={false}
                            search={false}
                            enableTopToolbar={false}
                            enableColumnFilters={false}
                            enablePagination={false}
                            state={{ isLoading: false }}
                        />
                    </div>
                </div>

                <div className="content-details">
                    <h4>{headerUnits}</h4>
                    <div className="table-search" style={{ overflow: 'hidden' }}>
                        <MantineReactTable
                            className="mantine-table"
                            columns={njesiteColumns}
                            data={njesite ?? []}
                            enableGlobalFilter={false}
                            enableGlobalFilterModes={false}
                            enableFilterMatchHighlighting={false}
                            enableGlobalFilterRankedResults={false}
                            enableBottomToolbar={false}
                            search={false}
                            enableTopToolbar={false}
                            enableColumnFilters={false}
                            enablePagination={false}
                            state={{ isLoading: false }}
                        />
                    </div>
                </div>

                <div className="content-details">
                    <h4>{headerActivity}</h4>
                    <div className="table-search" style={{ overflow: 'hidden' }}>
                        <MantineReactTable
                            className="mantine-table"
                            columns={aktivitetetColumns}
                            data={aktivitetet ?? []}
                            enableGlobalFilter={false}
                            enableGlobalFilterModes={false}
                            enableFilterMatchHighlighting={false}
                            enableGlobalFilterRankedResults={false}
                            enableBottomToolbar={false}
                            search={false}
                            enableTopToolbar={false}
                            enableColumnFilters={false}
                            enablePagination={false}
                            state={{ isLoading: false }}
                        />
                    </div>
                </div>

            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(TableDetails);
